import React from 'react';
import { Page, Text, Image, Font, Document, StyleSheet, View } from '@react-pdf/renderer';
import logoTc from "../assets/img/logo-tc-2.png"

Font.register({ family: 'Source Serif Pro', src: 'https://fonts.gstatic.com/s/sourceserifpro/v4/CeUM4np2c42DV49nanp55aqQQDHDiKO-LH8MFmRo0b0.ttf' });

const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      padding: 20,
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    separator: {
        marginTop: 30,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
      marginBottom: 20,
    },
    image: {
        // marginVertical: 15,
        // marginHorizontal: '100%',
        width: 81,
        height: 101,
    },
    imageFirma: {
        // marginVertical: 15,
        // marginHorizontal: 200,
        marginLeft: 400,
        float: 'right'
    },        
    text: {
      fontSize: 12,
      fontFamily: 'Times-Roman',
      textAlign: 'justify',
    },
    textBold: {
        fontSize: 12,
        fontFamily: 'Times-Bold',
        textAlign: 'justify',
    },
    textBoldInBox: {
        fontSize: 12,
        fontFamily: 'Times-Bold',
        textAlign: 'justify',
        border: '2 solid #000',
        padding: 6,
    },
    firma: {
        fontSize: 14,
        fontFamily: 'Times-Roman',
        textAlign: 'right',
        marginRight: '90'
    },    
    neuquen_a: {
        fontSize: 14,
        fontFamily: 'Source Serif Pro',
        textAlign: 'center',
      },
    neuquen_b: {
        fontSize: 16,
        fontFamily: 'Times-BoldItalic',
        textAlign: 'center',
    },
    neuquen_c: {
        fontSize: 12,
        fontFamily: 'Source Serif Pro',
        textAlign: 'center',
    },
    items: {
        fontSize: 12,
        fontFamily: 'Times-Bold',
        textAlign: 'left',
        // fontWeight: 'bolder'
    },
    
  });


// PAGE SIZE: https://github.com/diegomura/react-pdf/blob/master/packages/layout/src/page/getSize.ts

const ImprimirCedula = ({content}) => {
    return (
        <Document>
            <Page size="LETTER" style={styles.page}>

                <Text style={styles.neuquen_a} fixed>
                    <Image
                        style={styles.image}
                        src={logoTc}
                    />
                </Text>                
                <Text style={styles.neuquen_a} fixed>
                    PROVINCIA DEL NEUQUEN
                </Text>
                <Text style={styles.neuquen_b} fixed>
                    Tribunal de Cuentas
                </Text>
                <Text style={styles.neuquen_c} fixed>
                    ANEXO II
                </Text>
                <Text style={styles.neuquen_c} fixed>
                    REGLAMENTACIÓN DE LA LEY 2966
                </Text>
                <Text style={styles.neuquen_c} fixed>
                    (arts. 106, 106 bis y 106 ter de la Ley 2141)
                </Text>

                
                <Text style={styles.separator}></Text>


                <Text style={styles.items}>
                    Destinatario: {content.destinatario && content.destinatario.nombre} {content.destinatario && content.destinatario.apellido}
                </Text>
                <Text style={styles.items}>
                    Domicilio: {content.domicilio}
                </Text>
                <Text style={styles.items}>
                    Carácter: {content.caracter}
                </Text>
                <Text style={styles.items}>
                    Expediente N°: {content.expediente}
                </Text>
                <Text style={styles.items}>
                    Sector: {content.sector}
                </Text>
                {
                    content.tiene_copias && (
                        <Text style={styles.items}>
                            Cantidad: {content.fojas} Fojas
                        </Text>
                    )
                }

                {/* <Text style={styles.items}>
                    Observaciones adicionales:
                </Text> */}

                
                <Text style={styles.separator}></Text>


                <Text style={styles.text}>
                Hago saber a usted que en autos caratulados {content.expediente_caratula} (Expte. N° {content.expediente}), 
                en trámite por ante este Tribunal de Cuentas de la Provincia del Neuquén, sito en 
                Avda. Dr. Luis Federico Leloir N° 309 de la ciudad de Neuquén Capital, SE HA DISPUESTO NOTIFICARLE 
                lo siguiente:
                </Text>

                <Text style={styles.text}>
                    {content.desarrollo}
                </Text>

                {
                    content.documentos_adjuntados && (
                        <>
                            <Text style={styles.separator}></Text>

                            <Text style={styles.text}>
                                Se adjunta copia de: 
                            </Text>
                            <Text style={styles.text}>
                                {content.documentos_adjuntados}
                            </Text>
                        </>
        
                    )
                }

                <Text style={styles.separator}></Text>

                <Text style={styles.textBold}>
                    QUEDA UD. DEBIDAMENTE NOTIFICADO.-
                </Text>

                <Text style={styles.separator}></Text>

                <Text style={styles.text}>
                    A continuación se transcribe la normativa pertinente.-
                </Text>

                <Text style={styles.separator}></Text>

                <Text style={styles.textBoldInBox}>
                LUGAR y FECHA: NEUQUEN, {content.fecha_emision_formatted} - 
                </Text>
            </Page>
            <Page size="LETTER" style={styles.page}>

                <Text style={styles.neuquen_a} fixed>
                    <Image
                        style={styles.image}
                        src={logoTc}
                    />
                </Text>                
                <Text style={styles.neuquen_a} fixed>
                    PROVINCIA DEL NEUQUEN
                </Text>
                <Text style={styles.neuquen_b} fixed>
                    Tribunal de Cuentas
                </Text>
                <Text style={styles.neuquen_c} fixed>
                    ANEXO II
                </Text>
                <Text style={styles.neuquen_c} fixed>
                    REGLAMENTACIÓN DE LA LEY 2966
                </Text>
                <Text style={styles.neuquen_c} fixed>
                    (arts. 106, 106 bis y 106 ter de la Ley 2141)
                </Text>


                <Text style={styles.separator}></Text>

                <Text style={styles.textBoldInBox}>
                    CEDULA DD N°: {content.cedula}
                </Text>

                <Text style={styles.separator}></Text>

                <Text style={[styles.firma, {marginTop: 100}]}>
                    FIRMA
                </Text>    


                <Text style={styles.separator}></Text>

                <Text style={styles.text}>
                Se deja constancia que la presente diligencia se encuentro librada con firma digital conforme con la habilitación efectuada por la Ley Provincial N° 2.996, en los términos de lo dispuesto por la Ley Provincial N° 2.578, que adhiere a la Ley Nacional N° 25.506; firma cuya autenticidad de la fuente puede verifcarse a través del QR/link/hash pertinente.
                </Text>

                <Text style={styles.separator}></Text>


            </Page>            
        </Document>
    );
};

export default ImprimirCedula;